import styled from 'styled-components';

export const HighLowChartRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
